/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
import { dateFormat } from 'constants/formats';
import operationTypes from 'constants/operationTypes';
import operationTypesRealNames from 'constants/operationTypesRealNames';
import { format } from 'date-fns';
import { TranslateFn } from 'hooks/useTranslate';
import { Operation, Society } from 'types';
import { formatCurrencyDecimals } from 'utils/formats';
import { getOperationAmount } from './getOperationAmount';
import { getOperationSharesCount } from './getOperationSharesCount';

type FormatOperationLabelProps = {
  operation: Operation;
  isAdmin: boolean;
  countOperationTypes: Record<string, number>;
  actualSociety: Society;
  translate: TranslateFn;
};

export const formatOperationLAbel = ({
  operation,
  isAdmin,
  countOperationTypes,
  actualSociety,
  translate,
}: FormatOperationLabelProps) => {
  let result;

  const { operationType } = operation;
  const dateString = format(new Date(operation?.date), dateFormat);

  const comments =
    operation?.comments && isAdmin ? ` | ${operation?.comments}` : '';

  switch (operationType) {
    case operationTypes.CONSTITUTION: {
      result = `${dateString} | ${operationTypesRealNames[operationType]}`;
      break;
    }

    case operationTypes.CAPITAL_INCREASE: {
      result = `${dateString} | ${++countOperationTypes[operationType]}ª ${
        operationTypesRealNames[operationType]
      }${comments} | ${formatCurrencyDecimals(
        getOperationAmount(operation, actualSociety)
      )}`;
      break;
    }

    case operationTypes.CAPITAL_DECREASE: {
      result = `${dateString} | ${++countOperationTypes[operationType]}ª ${
        operationTypesRealNames[operationType]
      }${comments}`;
      break;
    }

    case operationTypes.SELL_PARTICIPATION: {
      result = `${dateString} |  ${++countOperationTypes[operationType]}ª ${
        operationTypesRealNames[operationType]
      } | ${translate('SharesSold')}: ${getOperationSharesCount(
        operation
      )}${comments}`;
      break;
    }

    case operationTypes.HERITAGE: {
      result = `${dateString} |  ${++countOperationTypes[operationType]}ª ${
        operationTypesRealNames[operationType]
      } | ${translate('TransmittedShares')}: ${getOperationSharesCount(
        operation
      )}${comments}`;
      break;
    }

    case operationTypes.DONATION: {
      result = `${dateString} |  ${++countOperationTypes[operationType]}ª ${
        operationTypesRealNames[operationType]
      } | ${translate('DonatedShares')}: ${getOperationSharesCount(
        operation
      )}${comments}`;
      break;
    }

    case operationTypes.TRANSMISSION: {
      result = `${dateString} |  ${++countOperationTypes[operationType]}ª ${
        operationTypesRealNames[operationType]
      } | ${translate('TransmittedShares')}: ${getOperationSharesCount(
        operation
      )}${comments}`;
      break;
    }

    case operationTypes.SPLIT: {
      result = `${dateString} |  ${++countOperationTypes[operationType]}ª ${
        operationTypesRealNames[operationType]
      } | ${translate('NrPart')}: ${getOperationSharesCount(
        operation
      )}${comments}`;
      break;
    }

    case operationTypes.RENUMERATION:
    case operationTypes.RECLASSIFICATION:
    case operationTypes.DIVIDENDS_DISTRIBUTION:
    case operationTypes.CONTRIBUTION:
    case operationTypes.ENDORSEMENT: {
      result = `${dateString} |  ${operationTypesRealNames[operationType]}${comments}`;
      break;
    }

    default:
      break;
  }

  return result;
};
